import { render, staticRenderFns } from "./detailTab.vue?vue&type=template&id=1feb9a97&scoped=true&"
import script from "./detailTab.vue?vue&type=script&lang=js&"
export * from "./detailTab.vue?vue&type=script&lang=js&"
import style0 from "./detailTab.vue?vue&type=style&index=0&id=1feb9a97&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1feb9a97",
  null
  
)

export default component.exports